import { deserializeInquiry } from './serializers'
import { IInquiry } from './types'

/**
 * Make an Inquiry as an authenticated user.
 * Call obtainAnswer after this to get the actual Answer for the calculation.
 *
 * Takes the id of the Calculator to associate the Inquiry with as the
 * first argument (ie. the one that requested it), and the inquiry submitted
 * by the Calculator as the second.
 */
export function createInquiry(calculatorId: string, inquiry: IInquiry) {
  const url = '/api/v1/mortgage-inquiries/'

  return window
    .axios({
      url,
      method: 'POST',
      data: {
        ...inquiry,
        answer: undefined
      }
    })
    .then(({ data }: any) => {
      return deserializeInquiry(calculatorId, data)
    })
}

/**
 * Get a Mortgage Inquiry Answer
 * Get the Answer for the given Inquiry Id.
 */
export function obtainAnswer(inquiryId?: number) {
  return window
    .axios({
      url: `/api/v1/mortgage-inquiries/${inquiryId}/obtain-answer/`,
      method: 'POST'
    })
    .then(({ data }: any) => {
      return data
    })
}
